(ns heraldicon.frontend.user.form.register
  (:require
   [cljs.core.async :refer [go]]
   [clojure.string :as str]
   [com.wsscode.async.async-cljs :refer [<?]]
   [heraldicon.frontend.api :as api]
   [heraldicon.frontend.language :refer [tr]]
   [heraldicon.frontend.message :as message]
   [heraldicon.frontend.modal :as modal]
   [heraldicon.frontend.user.form.confirmation :as confirmation]
   [heraldicon.frontend.user.form.core :as form]
   [heraldicon.util.email :as util.email]
   [heraldicon.util.username :as util.username]
   [re-frame.core :as rf]
   [taoensso.timbre :as log]))

(defn- form []
  [:form.modal-form {:on-submit (form/on-submit-fn [::submit])}
   [message/display ::id]
   [form/text-field ::id :username :string.user/username
    :label :string.user/username
    :help :string.user/username-help]
   [form/text-field ::id :email :string.user/email
    :label :string.user/email]
   [form/password-field ::id :password :string.user/password
    :label :string.user/password]
   [form/password-field ::id :password-again :string.user/password-again
    :label :string.user/password-again]

   [:div {:style {:text-align "right"
                  :margin-top "10px"}}
    [:button.button {:style {:margin-right "5px"}
                     :type "reset"
                     :on-click #(rf/dispatch [::form/clear-and-close ::id])}
     [tr :string.button/cancel]]

    [:button.button.primary {:type "submit"}
     [tr :string.menu/register]]]])

(rf/reg-event-fx ::show
  (fn [_ _]
    {:dispatch [::modal/create
                :string.menu/register
                [form]
                #(rf/dispatch [::form/clear ::id])]}))

(rf/reg-event-fx ::submit
  (fn [{:keys [db]} _]
    (let [{:keys [username password password-again email]} (form/data-from-db db ::id)
          email (str/trim (or email ""))
          username? (not (str/blank? username))
          email? (not (str/blank? email))
          valid-email? (util.email/valid-email? email)
          password? (not (str/blank? password))
          valid-username? (util.username/valid? username)]
      (cond-> {:dispatch-n [[::message/clear ::id]]}

        (not username?) (update :dispatch-n conj
                                [::message/set-error (form/message-id ::id :username)
                                 :string.user.message/username-required])
        (not valid-username?) (update :dispatch-n conj
                                      [::message/set-error (form/message-id ::id :username)
                                       :string.user.message/username-contains-invalid-characters])
        (not email?) (update :dispatch-n conj
                             [::message/set-error (form/message-id ::id :email)
                              :string.user.message/email-required])
        (and email?
             (not valid-email?)) (update :dispatch-n conj
                                         [::message/set-error (form/message-id ::id :email)
                                          :string.user.message/email-invalid])
        (not password?) (update :dispatch-n conj
                                [::message/set-error (form/message-id ::id :password)
                                 :string.user.message/password-required])
        (not= password
              password-again) (update :dispatch-n conj
                                      [::message/set-error (form/message-id ::id :password-again)
                                       :string.user.message/passwords-do-not-match])
        (and username?
             valid-username?
             valid-email?
             password?
             (= password
                password-again)) (assoc ::register [username email password])))))

(rf/reg-fx ::register
  (fn [[username email password]]
    (modal/start-loading)
    (go
      (try
        (<? (api/call :register {:username username
                                 :email email
                                 :password password} nil))
        (rf/dispatch [::form/clear-and-close ::id])
        (rf/dispatch [::confirmation/show username])
        (catch :default e
          (log/error e "registration error")
          (rf/dispatch [::message/set-error ::id (:message (ex-data e))]))
        (finally
          (modal/stop-loading))))))
